import jadeTheme from '@stone-payments/jade-design-tokens/cjs/stone';
import styled from 'styled-components';

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`;

export const GridItem = styled.div<{ removeLastPaddingBottom?: boolean }>`
  padding-top: ${jadeTheme.global.space[100]};
  display: grid;
  width: 100%;
  justify-self: stretch;
  &:last-child {
     padding-top: ${jadeTheme.global.space[200]};
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: ${({ removeLastPaddingBottom }) =>
          removeLastPaddingBottom ? '0' : jadeTheme.global.space[200]};
    }
`;
